import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import { useAuthStateSelector, useAuthStateManager } from 'hooks/auth';
import { Link as RLink } from 'react-router-dom';
import Link from 'components/Link';
import NavItem from './NavItem';

const Navbar = (): ReactElement => {
  const authState = useAuthStateSelector();
  const { deauthenticate } = useAuthStateManager();

  const onLogout = (): void => {
    deauthenticate();
  };

  return (
    <Layout>
      <RLink to="/" style={{ textDecoration: 'none' }}>
        <StyledBrand>Conway's Game of Life</StyledBrand>
      </RLink>
      <StyledNavList>
        {!authState.isAuthenticated && (
          <Link url="/login">
            <NavItem>Login</NavItem>
          </Link>
        )}
        {authState.isAuthenticated && (
          <>
            <Link url="/dashboard">
              <NavItem>Dashboard</NavItem>
            </Link>
            <NavItem onClick={onLogout}>Logout</NavItem>
          </>
        )}
      </StyledNavList>
    </Layout>
  );
};

const Layout = styled.header`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.75em 1.5em 0.5em 2.5em;
  background-color: lavender;
  position: sticky;
  top: 0;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StyledNavList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1.5vw;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StyledBrand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: black;
  font-size: 1.5em;

  @media (max-width: 600px) {
    margin-bottom: 0.75rem;
  }
`;

export default Navbar;
